<template lang="pug">
  Modal(
    @close="$emit('close-modal')"
    size="l"
    :class="$style.retrieveQuote"
    id="retrieve-quote"
    compact
    vertically-centered)

    Icon.logo-icon(
      color="#41a5dd"
      :size="34"
      name="i:av-logo-ppc")
    template(v-if="emailFormSubmit === null")
      p.title {{ $t("quote_modal.title") }}
      p.subtitle {{ $t("quote_modal.description") }}
    template(v-else-if="emailFormSubmit")
      div.success-container
        p.title
          | {{ $t("quote_modal.success.title") }}
          Icon.success-icon(
            color="#7ed321"
            :size="30"
            name="i:check-circle")
          br
          | {{ $t("quote_modal.success.description") }}
        p.subtitle
          | {{ $t("quote_modal.success.subtitle") }}
    template(v-else)
      p.title {{ $t("quote_modal.error.email_not_found") }}
      p.subtitle {{ $t("quote_modal.error.try_again") }}&nbsp;
        a(:href="getCategoriesLink()") {{ $t("quote_modal.error.here") }}
    VeeForm(
      ref="form"
      v-slot="{ field, errors }"
      :validation-schema="formSchema"
      @submit="submitEmailForm"
    )
      VeeField(name="email" v-slot="{ field, errorMessage }")
        TxtRefined(:placeholder="$t('quote_modal.email_placeholder')" input-id="email" v-bind="field" :model-value="email" @update:modelValue="handleEmail")
        VeeErrorMessage(name="email")
          TextInputError( class="mb-ds-md")
            | {{ $t("quote_modal.error.email_required") }}
      Btn(type="submit") {{ $t("quote_modal.submit_button") }}
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { object, string } from "yup"
import type { ValidationResult } from "vee-validate"
import { toTypedSchema } from "@vee-validate/yup"
import { ListingService } from "~/services/public/Listing"

export default defineComponent({
  name: "RetrieveQuoteModal",

  setup() {
    const formSchema = toTypedSchema(
      object({
        email: string().email().required()
      })
    )

    return { formSchema }
  },

  data() {
    return {
      listingService: new ListingService(this.$axios, this.$config.public),
      emailFormSubmit: null as boolean | null,
      email: ""
    }
  },

  methods: {
    async submitEmailForm() {
      const validationResult: ValidationResult = await (this.$refs.form as any).validate()

      if (validationResult.valid) {
        try {
          const response = await this.listingService.postEmail({
            email: this.email
          }, this.$i18n.locale)
          this.emailFormSubmit = response?.data.success
        } catch (err) {
          this.emailFormSubmit = false
          console.error("Email sending error", err)
        }
      }
    },

    handleEmail(value: string) {
      this.email = value
    },

    getCategoriesLink() {
      return this.listingService.getCategoriesLink()
    }
  }
})
</script>

<style lang="css" module>
.retrieveQuote {
  :global {
    .success-container {
      @apply mt-ds-md;

      svg {
        @apply ml-ds-sm mt-[-5px];
      }

      .title {
        @apply inline;
      }
      .subtitle {
        @apply mt-ds-ml;
      }
    }
    .title {
      @apply my-ds-md text-rebrandMd font-bold;
      line-height: normal;
    }
    .subtitle {
      @apply mb-ds-ml text-base;
      line-height: normal;
    }
    .text-input {
      @apply mb-ds-sm text-base;
    }
    button {
      @apply w-full text-rebrandSm;
    }
  }
}
</style>
